export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCXczqT92qhf6TBXjclZVOp__smaS1pj68',
  authDomain: 'qedit-console.firebaseapp.com',
  databaseURL: 'https://qedit-console.firebaseio.com',
  projectId: 'qedit-console',
  storageBucket: 'qedit-console.appspot.com',
  messagingSenderId: '151283637553',
  appId: '1:151283637553:web:b07e1681cc1eb3d5'
};
